<div class="p-3 mb-5 w-full justify-center flex flex-row">
  <markdown class="markdown-legal-style shadow-lg py-3 px-5 overflow-hidden max-w-[1080px]
                   w-full lg:w-11/12 xl:w-9/12 2xl:w-8/12"
            style="border: solid 1px #0001;"
            [src]="'assets/about.es.md'"></markdown>
</div>
